// extracted by mini-css-extract-plugin
export var dropdownContainer = "_3x-5";
export var imageContainer = "_3x-4";
export var metricsGrid = "_3x-2";
export var productDetailContainer = "_3x-1";
export var productListContainer = "_3x-0";
export var subscriberTableContainer = "_3x-3";